export {
  PlatformPersonas,
  PERSONA_TYPES,
  type Persona,
  PlatformPersonas as default,
} from '@cowbell/data';

// Named constants kept for callers that import them directly
export const UNKNOWN_PERSONA = 'UNKNOWN' as const;
export const RE_INSURER = 'RE_INSURER' as const;
export const PREMIUM_PROCESSOR = 'PREMIUM_PROCESSOR' as const;
